import React, { Component, PropTypes } from 'react'

import { sendPatchRequest } from '../utils'

import { Label, Select, TextInput } from '../ui'

export default class EmergencyForm extends Component {
    static propTypes = {
        data: PropTypes.object,
        errors: PropTypes.object.isRequired,
        options: PropTypes.object.isRequired,
        updateValue: PropTypes.func.isRequired,
        updateValueAndSendPatchRequest: PropTypes.func.isRequired,
    }

    render() {
        const errors = this.props.errors

        if (! this.props.data) {
            return null
        }

        return (
            <div className="form">
                <div className="grid grid--break-mobile">
                    <div className="grid__span-5">
                        <TextInput
                            error={ errors.emergency_contact_name }
                            handleBlur={ sendPatchRequest.bind(this, 'emergency_contact_name') }
                            label="First & Last name"
                            name="emergency_contact_name"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.emergency_contact_name }
                        />
                    </div>
                    <div className="grid__span-5">
                        <TextInput
                            error={ errors.emergency_contact_email }
                            handleBlur={ sendPatchRequest.bind(this, 'emergency_contact_email') }
                            label="E-mail"
                            name="emergency_contact_email"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.emergency_contact_email }
                        />
                    </div>
                </div>
                <div className="grid grid--break-mobile">
                    <Label>Cell Phone</Label>
                    <div className="grid__span-3">
                        <Select
                            error={ errors.emergency_contact_cell_dial_code }
                            name="emergency_contact_cell_dial_code"
                            options={ this.props.options.countryDialCodeOptions() }
                            placeholder="Select your country code"
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.emergency_contact_cell_dial_code }
                        />
                    </div>
                    <div className="grid__span-4">
                        <TextInput
                            error={ errors.emergency_contact_cell }
                            handleBlur={ sendPatchRequest.bind(this, 'emergency_contact_cell') }
                            name="emergency_contact_cell"
                            placeholder="999.999.9999"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.emergency_contact_cell }
                        />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/personal/emergency_form.js